import React, { Component, useEffect, useState } from "react";
import { useAlert } from "../context/AlertContext";
import { useLoading } from "context/LoadingContext";
import { fetchVendorLedger, downloadFiles } from "../Service/ApiService";
import { IconButton, Tooltip } from "@mui/material";
import { Download, RemoveRedEye } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const VendorLedgerController = () => {
  // Fetch vendor code from localstorage
  const vendordetails = JSON.parse(localStorage.getItem("vendor"));
  const vendorCode = vendordetails ? vendordetails.vendorCode : null;

  // Props
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [footer, setFooter] = useState([]);

  const [expand, setExpand] = useState(false);

  // Contexts
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  // Data
  const columnsFields = [
    { Header: "Month", accessor: "monthname", width: "5%", align: "left" },
    { Header: "Opening Balance", accessor: "opening_balance", align: "left" },
    { Header: "Debit", accessor: "debit", align: "left" },
    { Header: "Credit", accessor: "credit", align: "left" },
    { Header: "Balance", accessor: "balance", align: "left" },
    {
      Header: "View Ledger",
      accessor: "ledger",
      align: "center",
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => {
        // eslint-disable-next-line react/prop-types
        const rawMonthYear = row.original.monthname; // e.g., "March - 2025"

        // eslint-disable-next-line react/prop-types
        let [monthName, year] = rawMonthYear.split(" - ");

        const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth() + 1;
        const formattedMonth = monthIndex.toString().padStart(2, "0");

        // eslint-disable-next-line react/prop-types
        const openingBalance = row.original.balance.split(".")[1];

        // eslint-disable-next-line react/prop-types
        const viewLedger = row.original.viewledger;
        return (
          <Tooltip title="View">
            <span>
              <IconButton
                size="small"
                color="info"
                disabled={!viewLedger}
                onClick={() => {
                  if (!viewLedger) return; // Prevent action if disabled
                  navigate("/vendor-ledger-details", {
                    state: {
                      month: formattedMonth,
                      year,
                      opening: openingBalance,
                    },
                  });
                }}
              >
                <RemoveRedEye fontSize={"medium"} />
              </IconButton>
            </span>
          </Tooltip>
        );
      },
    },
    {
      Header: "Download",
      accessor: "download",
      align: "center",
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => {
        // eslint-disable-next-line react/prop-types
        const rawMonthYear = row.original.monthname; // e.g., "March - 2025"

        // eslint-disable-next-line react/prop-types
        let [monthName, year] = rawMonthYear.split(" - ");

        const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth() + 1;
        const formattedMonth = monthIndex.toString().padStart(2, "0");

        // eslint-disable-next-line react/prop-types
        const openingBalance = row.original.balance.split(".")[1];

        // eslint-disable-next-line react/prop-types
        const viewLedger = row.original.viewledger;

        return (
          <Tooltip title="Download">
            <IconButton size="small" color="success" disabled={!viewLedger}>
              <Download
                fontSize={"medium"}
                onClick={(e) => handleDownload(formattedMonth, year, openingBalance)}
              />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const expandedColumnFields = [];

  // Use Effects
  // Fetch vendor PO
  useEffect(() => {
    setColumns(columnsFields);
    getVendorLedger();
  }, []);

  const getVendorLedger = async () => {
    try {
      setLoading(true);

      const response = await fetchVendorLedger(vendorCode);

      if (response && response.success === "true") {
        // Set rows
        setRows(response.ledgerList);

        // Calculate totals
        const totalDebit = response.ledgerList.reduce(
          (sum, item) => sum + parseFloat(item.debit || 0),
          0
        );

        const totalCredit = response.ledgerList.reduce(
          (sum, item) => sum + parseFloat(item.credit || 0),
          0
        );

        setFooter({
          opening_balance: "Total",
          debit: totalDebit.toString(),
          credit: totalCredit.toString(),
        });
      } else {
        // Handle failure case: clear data
        setRows([]);
        setFooter({
          opening_balance: "Total",
          debit: 0,
          credit: 0,
        });
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error during fetching ledger data:", error);

      // Optional: fallback state
      setRows([]);
      setFooter({
        opening_balance: "Total",
        debit: 0,
        credit: 0,
      });
    }
  };

  // Download File
  const handleDownload = async (formattedMonth, year, openingBalance) => {
    setLoading(true);
    const param = `vendorCode=${vendorCode}&month=${formattedMonth}&year=${year}&opening=${openingBalance}`;
    const response = await downloadFiles(
      param,
      "vendor/vendorledgerDownalod.php",
      "vendorLedgerFile.xls"
    );
    if (response == true) {
      showAlert("File successfully download!", {
        icon: "success",
        title: "Success",
      });
    }

    setLoading(false);
  };

  // Expand table
  const toggleExpand = () => {
    const newExpand = !expand;
    setExpand(newExpand);

    if (newExpand) {
      setColumns([...columnsFields, ...expandedColumnFields]);
    } else {
      setColumns(columnsFields);
    }
  };

  return {
    columns,
    rows,
    footer,
    expand,
    toggleExpand,
    handleDownload,
  };
};

export default VendorLedgerController;
